// extracted by mini-css-extract-plugin
module.exports = {"btn":"MenuBtn_btn__3VUZ0","_active":"MenuBtn__active__3riBx"};